export const ROUTE_PATHS = {
  HOME: '/',
  ACCESS_DENIED: '/access-denied',
  ORGANIZATION_DETAILS: '/organizations/details/:organizationId',
  EVENT_PAGE_HANDLER: '/event-page-handler',
  QUEUES: '/queues',
  CRAWL_QUEUE: '/crawl-queue',
  CREATE_ORGANIZATION: '/organizations/create',
  PREFERENCES: '/preferences',
  QUEUE: '/queue',
  DRAFT_PRODUCTIONS: '/draft-productions',
};
